import React, { useEffect, useLayoutEffect, useState } from 'react'
import 'lazysizes'
import { LayoutProps } from '../model/CustomModel'
import { useLocation } from 'react-router-dom'
import * as queryString from 'query-string'
import { useDispatch } from 'react-redux'
import { styleActions } from '../store/style'
import { useSelector } from '../store'

const WebviewLayout: React.FunctionComponent<LayoutProps> = ({ children }) => {
    const location = useLocation()
    const search = queryString.parse(location.search)
    const dispatch = useDispatch();
    const style=useSelector(state => state.style);
    const [theme,setTheme]=useState(style.theme);
    useLayoutEffect(() => {
        console.log('web view layout effect')
        return () => console.log('Layout 사라짐')
    })
    useEffect(() => {
        //setTheme(search.theme ? search.theme.toString() : 'default')
        //setMetaTags({title:'종이스탬프의 감성 그대로!',description:'적립 및 할인 혜택이 풍성한 제이스탬프 제이스탬프입니다',imageUrl:'/jstamp.jpg'});
        //return ()=>{ setMetaTags({}); }+
        console.log('WebviewLayout effect:theme='+search.theme);
        const th=search.theme? search.theme.toString():'default';
        setTheme(th);
        dispatch(styleActions.setModel({ theme: th}));
        return () => console.log('use effect end')
    }, [])
    return (
        <>
            {/*<ReactHelmet
                keywords="제이스탬프,jstamp,boxtree,박스트리"
                description="적립 및 할인 혜택이 풍성한 제이스탬프 제이스탬프입니다. 여기를 눌러 확인하세요."
                title="종이스탬프의 감성 그대로!"
            />*/}
            {/*<LoadingHtml parent={true}/>*/}
            <div className={`page-container ${theme}`}>
                {children}
            </div>
        </>
    )

}
export default WebviewLayout
